module.exports = __webpack_public_path__ + "static/water-3458c642fd45b3b4866bd34a5f560afc.mp4";